import { createFileRoute } from "@tanstack/react-router";
import AdminGuard from "@/components/AdminGuard";
import AdminKnowledge from "@/pages/AdminKnowledge";

export const Route = createFileRoute("/en/admin/knowledge")({
  component: () => (
    <AdminGuard>
      <AdminKnowledge />
    </AdminGuard>
  ),
});
